@use '@workbench/core/dist/scss/_utility.scss' as utility;

.toggle-button {
  width: fit-content;
}

.category-label {
  @include utility.wb-text(
    'm',
    (
      strong: true,
    )
  );
}
